import React from 'react';
import { Advertorial } from './pages/Advertorial';
export function App() {
  return <Advertorial data-id="element-0" />;
}